import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  CircleHelp, Globe2, Home, LayoutGrid, Menu, MessageSquareText, Settings, UserRound, X,
} from "lucide-react";

export function StudioRail({ isAdmin }: { isAdmin: boolean }) {
  const location = useLocation();
  const onAdmin = location.pathname === "/admin" || location.pathname.startsWith("/admin/");
  const [mobileOpen, setMobileOpen] = useState(false);
  const nav = [
    { to: "/dashboard", label: "Home", icon: Home },
    { to: "/sites", label: "My sites", icon: LayoutGrid },
    { to: "/domains", label: "Web address", icon: Globe2 },
    { to: "/leads", label: "Leads", icon: MessageSquareText },
  ];
  return (
    <>
      <button className="mobile-nav-toggle" onClick={() => setMobileOpen((value) => !value)} aria-label="Toggle navigation">{mobileOpen ? <X size={20} /> : <Menu size={20} />}</button>
      <aside className={`studio-rail${mobileOpen ? " open" : ""}`}>
        <nav aria-label="ProtoPal navigation">
          {nav.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => `rail-link${isActive ? " active" : ""}`} data-tip={label} aria-label={label} onClick={() => setMobileOpen(false)}>
              <Icon size={20} /><span>{label}</span>
            </NavLink>
          ))}
          <div className="rail-divider" />
          <NavLink to="/help" className={({ isActive }) => `rail-link${isActive ? " active" : ""}`} data-tip="Help" aria-label="Help"><CircleHelp size={20} /><span>Help</span></NavLink>
          <NavLink to="/account" className={({ isActive }) => `rail-link${isActive ? " active" : ""}`} data-tip="Settings" aria-label="Settings"><Settings size={20} /><span>Settings</span></NavLink>
          {isAdmin && <Link to="/admin" className={`rail-link${onAdmin ? " active" : ""}`} data-tip="Admin" aria-label="Admin"><UserRound size={20} /><span>Admin</span></Link>}
        </nav>
      </aside>
    </>
  );
}

